'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { NavPathname } from '@/components/NavPathname';
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from '@/components/ui/sidebar';
type Item = {
  title: string;
  url: string;
  icon?: React.ReactNode;
  isActive?: boolean;
};
export function NavMain(t0) {
  const $ = _c(4);
  const {
    items
  } = t0;
  let t1;
  if ($[0] !== items) {
    t1 = items.map(_temp);
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <SidebarMenu>{t1}</SidebarMenu>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(item) {
  return <NavPathname key={item.title}>{pathname => <SidebarMenuItem className="flex"><SidebarMenuButton isActive={pathname === item.url} tooltip={item.title} asChild={true}><Link href={item.url} className="flex">{item.icon && item.icon}<span>{item.title}</span></Link></SidebarMenuButton></SidebarMenuItem>}</NavPathname>;
}